/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Abandon_Vekn_HintInputs */



/**
* | output |
* | --- |
* | "You or a National Coordinator can claim the VEKN ID again later." |
*
* @param {Profile_Abandon_Vekn_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_abandon_vekn_hint = /** @type {((inputs?: Profile_Abandon_Vekn_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Abandon_Vekn_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous ou un Coordinateur National pourrez revendiquer à nouveau le VEKN ID plus tard.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Usted o un Coordinador Nacional pueden reclamar el ID VEKN nuevamente más tarde.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Você ou um Coordenador Nacional pode reivindicar o VEKN ID novamente depois.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tu o un Coordinatore Nazionale potrete reclamare nuovamente il VEKN ID in seguito.")
	return /** @type {LocalizedString} */ ("You or a National Coordinator can claim the VEKN ID again later.")
});